import { ActionIcon, Avatar, Group, Stack, Text, Tooltip } from '@mantine/core'
import { IconPencil } from '@tabler/icons-react'

import avatars from '@/assets/avatars'

// Minimal interface for sidekick display
interface SidekickDisplay {
  title: string
  name: string
  avatarId: string
  isPSK?: boolean
}

interface SidekickButtonProps {
  selectedSidekick: SidekickDisplay | null
  onClick: () => void
  disabled?: boolean
}

export function SidekickButton({ selectedSidekick, onClick, disabled = false }: SidekickButtonProps) {
  const content = (
    <Stack gap="xs">
      <Group gap="xs" align="center">
        <Avatar
          src={selectedSidekick ? avatars[selectedSidekick.avatarId] || avatars.placeholder : avatars.placeholder}
          size="lg"
          radius="50%"
          style={{
            border: '1px solid #dee2e6',
          }}
        />
        <Stack gap="xs">
          <Text size="xs" ta="center" c="dimmed" fw="bold">
            {selectedSidekick?.title}
          </Text>
          <Text size="xs" ta="left">
            {selectedSidekick?.name}
          </Text>
          <ActionIcon variant="light" size="md" onClick={onClick} aria-label="Change sidekick" disabled={disabled}>
            <IconPencil size={18} />
          </ActionIcon>
        </Stack>
      </Group>
    </Stack>
  )

  if (disabled) {
    return (
      <Tooltip
        label="Sidekick cannot be modified when Content Modules are assigned to a Topic"
        withArrow
        position="top"
        multiline
        styles={{
          tooltip: {
            maxWidth: '250px',
          },
        }}>
        <div>{content}</div>
      </Tooltip>
    )
  }

  return content
}
